/**
 * authExpiry - one shared definition of "the server rejected these
 * credentials" for the whole client.
 *
 * Why this exists (2026-11-04 save loss): an expired session token
 * made /api/designs answer 403 while /api/auth/me answered 401, and
 * every consumer handled only one of the two - the designs hook only
 * treated 401 as an auth failure, so a dead token left the account
 * looking enabled, saves died against the account, and the app kept
 * presenting the user as signed in. Every authed call site now uses
 * isAuthFailureStatus, and any of them can raise notifyAuthExpired()
 * so AuthContext reconciles the whole app to a truthful signed-out
 * state instead of an avatar on a corpse token.
 */

/** 401 (unauthenticated) and 403 (legacy invalid-token answer) both mean the session is dead. */
export const isAuthFailureStatus = (status: number): boolean => status === 401 || status === 403;

/** Window event raised when any API call learns the session is dead. */
export const AUTH_EXPIRED_EVENT = 'oc:auth-expired';

export function notifyAuthExpired(): void {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
    }
}
